// components/ComingSoon.jsx
import React from 'react';

const ComingSoon = ({ sectionName }) => {
  return (
    <div className="flex items-center justify-center h-96">
      <div className="text-center">
        <div className="w-32 h-32 bg-gradient-to-br from-green-100 to-green-200 rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg animate-pulse">
          <span className="text-4xl">🚧</span>
        </div>
        <h2 className="text-3xl font-bold text-gray-800 mb-4">
          {sectionName}
        </h2>
        <p className="text-gray-600 text-lg mb-8 max-w-md">
          We're working hard to bring you this feature. Stay tuned for updates!
        </p>
        <div className="inline-flex items-center space-x-2 bg-green-100 text-green-700 px-6 py-3 rounded-full font-semibold">
          <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
          <span>Coming Soon</span>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;